import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Identity } from '@vendorflow/types'
import Lightbox from 'pages/WorkspacePage/Lightbox'
import React, { createContext, ReactNode, useContext, useReducer } from 'react'
import { MediaAsset } from 'pages/WorkspacePage/ChannelView/ChannelInterfaceProvider/ChannelInterface.types'

export interface State {
  open: boolean
  assets: MediaAsset[]
  selected: number
  alice: Identity | null
}

export interface LightboxContextValue {
  open: State['open']
  assets: State['assets']
  selected: State['selected']
  alice: State['alice']
  setLightboxOpen: (value: State['open']) => void
  setLightboxAssets: (value: State['assets']) => void
  setLightboxSelected: (value: State['selected']) => void
  setLightboxAlice: (value: State['alice']) => void
}

const initialState: State = {
  open: false,
  assets: [],
  selected: 0,
  alice: null,
}

const slice = createSlice({
  name: 'LightboxSlice',
  initialState,
  reducers: {
    setLightboxOpen(state, action: PayloadAction<State['open']>) {
      state.open = action.payload
    },
    setLightboxAssets(state, action: PayloadAction<State['assets']>) {
      state.assets = action.payload
    },
    setLightboxSelected(state, action: PayloadAction<State['selected']>) {
      state.selected = action.payload
    },
    setLightboxAlice(state, action: PayloadAction<State['alice']>) {
      state.alice = action.payload
    },
  },
})

const { reducer, actions } = slice

export const LightboxContext = createContext<LightboxContextValue | undefined>(undefined)

export function useLightboxContext() {
  return useContext(LightboxContext)!
}

export default function LightboxProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState)

  function setLightboxOpen(value: State['open']) {
    dispatch(actions.setLightboxOpen(value))
  }

  function setLightboxAssets(assets: State['assets']) {
    dispatch(actions.setLightboxAssets(assets))
  }

  function setLightboxSelected(value: State['selected']) {
    dispatch(actions.setLightboxSelected(value))
  }
  function setLightboxAlice(value: State['alice']) {
    dispatch(actions.setLightboxAlice(value))
  }

  return (
    <LightboxContext.Provider
      value={{ ...state, setLightboxOpen, setLightboxAssets, setLightboxSelected, setLightboxAlice }}
    >
      <Lightbox />
      {children}
    </LightboxContext.Provider>
  )
}
